import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["container", "viewButton", "deviceButton", "frame"];
  static values = {
    initialViewType: String,
    initialDeviceType: String,
  };

  connect() {
    const urlParams = new URLSearchParams(window.location.search);
    this.viewType = urlParams.get('view_type') || this.initialViewTypeValue;
    this.deviceType = urlParams.get('device_type') || this.initialDeviceTypeValue;

    this.updateButtons();
    this.updateContainerSize();

    // 부모 창(에디터)에서 호출할 수 있도록 전역 함수를 설정합니다.
    window.refreshPreview = () => this.reloadFrame();
    window.scrollToBlock = (blockId) => this.scrollTo(blockId);

    // 부모 창에 준비되었음을 알립니다.
    if (window.opener && typeof window.opener.connectPreview === "function") {
      window.opener.connectPreview(window);
    }
  }

  // --- Actions ---

  switchView(event) {
    const newViewType = event.currentTarget.dataset.viewType;
    if (this.viewType === newViewType) return;

    this.viewType = newViewType;
    this.updateButtons();

    // ★★★★★ 수정: Turbo Frame 업데이트 대신 전체 페이지를 리로드합니다. ★★★★★
    const newUrl = new URL(window.location.href);
    newUrl.searchParams.set('view_type', this.viewType);

    // 현재 디바이스 타입을 쿼리 파라미터에 추가하여,
    // 리로드 후에도 디바이스 선택이 유지되도록 합니다.
    newUrl.searchParams.set('device_type', this.deviceType);

    // Turbo를 사용하여 페이지를 방문하면 부드럽게 전환됩니다.
    // window.Turbo.visit(newUrl.toString());
    // 또는 간단하게
    window.location.href = newUrl.toString();
  }

  switchDevice(event) {
    const newDeviceType = event.currentTarget.dataset.deviceType;
    if (this.deviceType === newDeviceType) return;

    this.deviceType = newDeviceType;
    this.updateButtons();
    this.updateContainerSize();
  }

  // --- Public methods for parent window ---

  reloadFrame() {
    if (!this.hasFrameTarget) {
      console.error("❌ 'frame' target is missing. Cannot reload.");
      return;
    }

    // ★★★★★ 핵심 수정 ★★★★★
    // reload()를 호출하기 전에, 현재 상태에 맞는 src를 다시 한번 보장해줍니다.
    const expectedSrc = new URL(window.location.pathname, window.location.origin);
    expectedSrc.searchParams.set('view_type', this.viewType);

    // 만약 현재 src가 예상과 다르다면, 먼저 설정부터 합니다.
    if (this.frameTarget.src !== expectedSrc.toString()) {
      console.warn("Frame src is outdated. Updating before reload.", {
        current: this.frameTarget.src,
        expected: expectedSrc.toString()
      });
      this.frameTarget.src = expectedSrc.toString();
      // src를 변경하면 자동으로 리로드가 트리거되므로, 수동 reload() 호출이 필요 없을 수 있습니다.
      // 하지만 명시적으로 호출하는 것이 더 확실한 동작을 보장합니다.
    }

    try {
      this.frameTarget.reload();
    } catch (e) {
      console.error("Error while reloading frame:", e);
    }
  }

  scrollTo(blockId) {
    if (!blockId) return;

    const element = this.frameTarget.querySelector(`[data-block-id="${blockId}"]`);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'center' });
      // 하이라이트 효과 (선택사항)
      document.querySelectorAll('.is-highlighted').forEach(el => el.classList.remove('is-highlighted'));
      element.classList.add('is-highlighted');
      setTimeout(() => element.classList.remove('is-highlighted'), 1500);
    }
  }

  // --- UI Update Helpers ---

  updateButtons() {
    this.viewButtonTargets.forEach(btn => {
      btn.classList.toggle('is-active', btn.dataset.viewType === this.viewType);
    });
    this.deviceButtonTargets.forEach(btn => {
      btn.classList.toggle('is-active', btn.dataset.deviceType === this.deviceType);
    });
  }

  updateContainerSize() {
    this.containerTarget.classList.remove('is-pc', 'is-mobile');
    this.containerTarget.classList.add(`is-${this.deviceType}`);
  }
}